/**
 * 全局模版状态
 * @author VenDream
 * @since 17/12/04
 */

import { getUrlWithHttpsProtocol } from '@fe/common/lib/url';
import VARIABLES from 'constants/variable.json5';
import ACTIONS from 'constants/action.json5';

import { isInEditorIframe } from 'utils/env';

const inEditorIframe = isInEditorIframe();

const initialState = {
  byId: {},
  ids: [],
};

// 转换/扩展模板数据结构
export function transferTplData(tpl) {
  const tplExtOpt = JSON.parse(tpl.tplExt);
  const newTpl = {
    ...tpl,
    type:
      tpl.tplSpecies === '1'
        ? VARIABLES.RP_H5
        : tpl.tplSpecies === '2'
        ? VARIABLES.RP_SPA
        : tpl.tplSpecies === '3'
        ? VARIABLES.RP_VIDEO
        : tpl.tplSpecies === '15'
        ? VARIABLES.POSTER
        : VARIABLES.RP_GAME,
    cover: getUrlWithHttpsProtocol(tpl.tplCoversFilepath),
    width: tplExtOpt && tplExtOpt.width,
    height: tplExtOpt && tplExtOpt.height,
    //这里同时会有老接口、新接口数据处理
    views: tpl.tplViewcount || tpl.tplViewCount,
    price: tpl.tplPrice,
    promotion:
      (tpl?.filterItems?.tplDepreciation
        ? +tpl.filterItems.tplDepreciation
        : 0) || +tpl.minusValue,
    // isCollectionTpl collectionTpl 可以同时出现undefined的情况，需要给一个默认值false
    isCollectionTpl: tpl.isCollectionTpl || tpl.collectionTpl || false,
  };

  /**
   * 2021年9月7日 by zhouruibin
   * 由于模板市场嵌入在编辑器中显示时 需要强行过滤掉 游戏和短视频类模板 故在此做改造
   */
  if (newTpl.type === VARIABLES.RP_VIDEO) {
    if (inEditorIframe) return null;
    try {
      const videoSrc = JSON.parse(tpl.video);
      const videoCover = JSON.parse(tpl.image);

      // 视频链接显式声明为https
      Object.keys(videoSrc).map(
        quality =>
          (videoSrc[quality] = getUrlWithHttpsProtocol(videoSrc[quality]))
      );
      // 视频封面图片显式声明为https
      Object.keys(videoCover).map(
        size => (videoCover[size] = getUrlWithHttpsProtocol(videoCover[size]))
      );

      newTpl.video = videoSrc;
      newTpl.cover = videoCover;
    } catch (e) {
      console.error(e);

      newTpl.video = {};
      newTpl.cover = {};
    }
  }
  if (newTpl.type === VARIABLES.RP_GAME) {
    if (inEditorIframe) return null;
    // 小游戏模板删除多余数据结构
    try {
      delete newTpl.price;
      delete newTpl.promotion;
      delete newTpl.views;
      delete newTpl.tplCoversFilepath;
    } catch (e) {
      console.log(e);
    }
  }
  return newTpl;
}

export function preProcessTplData(oldState, newState) {
  if (oldState && newState) {
    const oldTplViewcount = oldState.tplViewcount;
    const newTplViewcount = newState.tplViewcount;

    newState.tplViewcount =
      oldTplViewcount > newTplViewcount ? oldTplViewcount : newTplViewcount;
  }
}

// 获取覆盖后的state（粒度精确到模版对象）
function getStateAfterCovering(state, newState, loadType) {
  const coveredState = { ...state };

  for (const [id, tpl] of Object.entries(newState.byId)) {
    const originTpl = coveredState.byId[id];
    coveredState.byId[id] = {
      ...tpl,
      ...originTpl,
    };
    !coveredState.byId[id] && coveredState.ids.concat(id);
  }
  return loadType === 'click' ? newState : coveredState;
}

// 将模版列表数据转换为tpls对应的结构
const transferTplToNewTpl = tpls => {
  const newTpls = { byId: {}, ids: [] };

  for (const tpl of tpls) {
    if (tpl && tpl.id) {
      const tplData = transferTplData(tpl);
      if (tplData) {
        newTpls.byId[tpl.id] = tplData;
        newTpls.ids.push(tpl.id);
      }
    }
  }
  return newTpls;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_TPLS_SUCCEED:
    case ACTIONS.SET_TEMPLATES: {
      const { tpls, loadType } = action.payload;
      const newTpls = transferTplToNewTpl(tpls);
      return getStateAfterCovering(state, newTpls, loadType);
    }
    case ACTIONS.CLEAR_STORE_TPLS: {
      return { byId: {}, ids: [] };
    }
    case ACTIONS.SET_CONTENT_TOPIC_DETAIL: {
      const { columns } = action.data;
      let tpls = [];

      for (const column of columns) {
        tpls = tpls.concat(column.templates);
      }

      const newTpls = transferTplToNewTpl(tpls);
      return getStateAfterCovering(state, newTpls);
    }
    case ACTIONS.SET_TPL_COLLECTION_STATUS: {
      const { tplId, isCollectionTpl } = action.payload;
      return {
        ...state,
        byId: {
          ...state.byId,
          [tplId]: {
            ...state.byId[tplId],
            isCollectionTpl,
          },
        },
      };
    }
    case ACTIONS.SET_TEMPLATE:
    case ACTIONS.SET_TEMPLATE_ERROR: {
      const { id } = action.data;
      preProcessTplData(state.byId[id], action.data);
      const template =
        action.data.status === VARIABLES.ERROR
          ? action.data
          : transferTplData(action.data);

      return {
        ...state,
        byId: {
          ...state.byId,
          [id]: {
            ...state.byId[id],
            ...template,
          },
        },
      };
    }
    default:
      return state;
  }
};
